function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
export class WebEventResponderInstance {
  constructor(props) {
    _defineProperty(this, "eventHandlers", void 0);

    this.eventHandlers = props;
  }

}

class WebEventResponderStatic {
  static create(config) {
    return new WebEventResponderInstance({
      onMouseEnter: () => {
        config.onMouseEnter && config.onMouseEnter();
      },
      onMouseLeave: () => {
        config.onMouseLeave && config.onMouseLeave();
      },
      onFocus: () => {
        config.onFocus && config.onFocus();
      },
      onBlur: () => {
        config.onBlur && config.onBlur();
      }
    });
  }

}

export const WebEventResponder = WebEventResponderStatic;